import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import Polyglot from 'node-polyglot';
import merge from 'lodash/merge';
import noop from 'lodash/noop';
import { DEFAULT_PHRASES } from './locales';
const I18nContext = /*#__PURE__*/ createContext(null);
export const RCCI18n = (props)=>{
    const { localePhrases, defaultLocale = 'sv', fallbackLocale = 'sv', children } = props;
    // Merga ihop defaultfraser med custom som skickas in.
    const locales = useMemo(()=>{
        return merge({}, DEFAULT_PHRASES, localePhrases);
    }, [
        localePhrases
    ]);
    const [locale, setLocale] = useState(defaultLocale);
    // Fallback som används då frasen inte finns översatt för vald locale.
    const fallbackPolyglot = useMemo(()=>{
        return new Polyglot({
            phrases: locales[fallbackLocale],
            locale: fallbackLocale,
            allowMissing: true
        });
    }, [
        fallbackLocale,
        locales
    ]);
    const localePolyglot = useMemo(()=>{
        if (locale === fallbackLocale) {
            return fallbackPolyglot;
        }
        return new Polyglot({
            phrases: locales[locale],
            locale: locale,
            allowMissing: true,
            onMissingKey (phrase, options) {
                return fallbackPolyglot.t(phrase, options);
            }
        });
    }, [
        locale,
        locales,
        fallbackPolyglot,
        fallbackLocale
    ]);
    // TODO: kanske exponera mer här, tex extend.
    const ctx = useMemo(()=>{
        return {
            locale,
            setLocale,
            t: localePolyglot.t.bind(localePolyglot)
        };
    }, [
        locale,
        setLocale,
        localePolyglot
    ]);
    return /*#__PURE__*/ _jsx(I18nContext.Provider, {
        value: ctx,
        children: children
    });
};
// Skapa ett defaultkontext ifall man glömmer wrappa sin kod i RCCI18n.
const DEFAULT_POLYGLOT = new Polyglot({
    phrases: DEFAULT_PHRASES['sv'],
    locale: 'sv',
    allowMissing: true,
    onMissingKey (phrase) {
        return phrase;
    }
});
const NOOP_CTX = {
    locale: 'not_set',
    setLocale: noop,
    t: DEFAULT_POLYGLOT.t.bind(DEFAULT_POLYGLOT)
};
export const useI18n = ()=>{
    return useContext(I18nContext) || NOOP_CTX;
};
